import React from "react";
import { Layout } from "../../components/layout/Layout";
import { ModuleRouter } from "../../components/molecules/ModuleRouter";
import { CameraRoute } from "./camera.routes";

export function Camera() {
  return (
    <Layout>
      {CameraRoute.subRoutes && (
        <ModuleRouter subRoutes={CameraRoute.subRoutes} path={CameraRoute.path} />
      )}
    </Layout>
  );
}
